var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSplitIconLargeActive = function SvgSplitIconLargeActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_52",
    "data-name": "Group 52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 56.25,
    viewBox: "0 0 100 56.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M732.588,411.938h-99v-55.25h99Z",
    transform: "translate(-633.088 -356.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M634.088,357.188v54.25h98v-54.25h-98m-1-1h100v56.25h-100Z",
    transform: "translate(-633.088 -356.188)",
    fill: "#024"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M636.088,359.188h70.6v49.25h-70.6Z",
    transform: "translate(-633.088 -356.188)",
    fill: "#024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-2",
    "data-name": "Grey Box-2",
    d: "M708.688,376.318h21.335v14.989H708.688Z",
    transform: "translate(-633.088 -356.188)",
    fill: "#024"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSplitIconLargeActive);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfNTIiIGRhdGEtbmFtZT0iR3JvdXAgNTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCIgaGVpZ2h0PSI1Ni4yNSIgdmlld0JveD0iMCAwIDEwMCA1Ni4yNSI+CiAgPGcgaWQ9IldoaXRlX0JveCIgZGF0YS1uYW1lPSJXaGl0ZSBCb3giPgogICAgPHBhdGggaWQ9IlBhdGhfMSIgZGF0YS1uYW1lPSJQYXRoIDEiIGQ9Ik03MzIuNTg4LDQxMS45MzhoLTk5di01NS4yNWg5OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MzMuMDg4IC0zNTYuMTg4KSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMiIgZGF0YS1uYW1lPSJQYXRoIDIiIGQ9Ik02MzQuMDg4LDM1Ny4xODh2NTQuMjVoOTh2LTU0LjI1aC05OG0tMS0xaDEwMHY1Ni4yNWgtMTAwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYzMy4wODggLTM1Ni4xODgpIiBmaWxsPSIjMDI0Ii8+CiAgPC9nPgogIDxwYXRoIGlkPSJHcmV5X0JveCIgZGF0YS1uYW1lPSJHcmV5IEJveCIgZD0iTTYzNi4wODgsMzU5LjE4OGg3MC42djQ5LjI1aC03MC42WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYzMy4wODggLTM1Ni4xODgpIiBmaWxsPSIjMDI0Ii8+CiAgPHBhdGggaWQ9IkdyZXlfQm94LTIiIGRhdGEtbmFtZT0iR3JleSBCb3gtMiIgZD0iTTcwOC42ODgsMzc2LjMxOGgyMS4zMzV2MTQuOTg5SDcwOC42ODhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjMzLjA4OCAtMzU2LjE4OCkiIGZpbGw9IiMwMjQiLz4KPC9zdmc+Cg==";